const initialState = {
    loadedItem : null,
    selectedRef : null,
    loading: false,
    donation : null,
    mapSelection : {}
}

export default (state = initialState, action) => {
    let attrs = {};

    switch (action.type) {

        case 'SET_VOLUNTEER_REQUEST':
            return {...state, selectedRef: action.payload, loading : true}

        // case 'UPDATE_INVENTORY_PLEDGE_QUANTITY':
        //     attrs.donation = {...state.donation};
        //     attrs.donation.quantity = action.payload;
        //     return {...state, ...attrs}

        case 'UPDATE_INVENTORY_PLEDGE_USER':
            attrs.donation = {...state.donation};
            if(action.payload.key=='email'){ attrs.donation.givrEmail = action.payload.value  };
            if(action.payload.key=='firstName'){ attrs.donation.givrFirstName = action.payload.value  };
            if(action.payload.key=='lastName'){ attrs.donation.givrLastName = action.payload.value  };
            return {...state, ...attrs}

        case 'UPDATE_VOLUNTEER_PLEDGE':
            return {...state, donation : action.payload}

        case 'UPDATE_VOLUNTEER_MAP_SELECT':
            return {...state, mapSelection : action.payload || {} }

        case 'RESET':
            return { ...initialState }
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/reducers/volunteerReducer.js